var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cancel-sub-btn text-center"},[_c('button',{staticClass:"mr-btn btn-tertiary",on:{"click":_vm.editAutoDeliveryCancelFinalModal}},[_vm._v("Cancel Subscription")])])}
var staticRenderFns = []

export { render, staticRenderFns }